import React, { PropsWithChildren } from 'react';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { CheckmarkFilledIcon, CloseFilledIcon } from '@cp/ds/src/icons';
import { styled } from '@cp/ds/src/theme';

const ResultRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '&[data-state="success"]': {
    color: theme.palette.success.main,
  },
  '&[data-state="failure"]': {
    color: theme.palette.error.main,
  },
  '& > svg': {
    fontSize: '20px',
  },
}));

interface ResultProps extends BoxProps, PropsWithChildren {
  state: 'success' | 'failure';
  Icon: React.ComponentType;
}
const Result: React.FC<ResultProps> = ({ state, Icon, children, ...props }) => (
  <ResultRoot data-state={state} {...props}>
    <Icon />
    <Typography variant="body bold">{children}</Typography>
  </ResultRoot>
);

export interface StepResultProps extends BoxProps, PropsWithChildren {
  state?: 'success' | 'failure';
}
export const StepResult: React.FC<StepResultProps> = ({ state, children, ...props }) => {
  return (
    <Box {...props}>
      {state === 'success' && (
        <Result Icon={CheckmarkFilledIcon} state="success">
          Вы ответили правильно!
        </Result>
      )}
      {state === 'failure' && (
        <Result Icon={CloseFilledIcon} state="failure">
          Вы ответили неверно
        </Result>
      )}
      {children}
    </Box>
  );
};
